import styled from 'styled-components';

import { FontSizes, FontWeights, Text, TextElements, units } from '@calm-web/design-system';

export const Container = styled.div`
	margin-left: ${units(2)};
	margin-bottom: ${units(3)};
`;

export const SubsectionTitle = styled(Text).attrs({
	el: TextElements.H3,
	weight: FontWeights.Light,
	size: FontSizes.lg,
})`
	margin-bottom: ${units(1.4)};
`;

export const SubsectionBody = styled.div`
	margin-left: ${units(2)};
`;
